<template>
    <div v-if="!loadingPage" class="pb-2">
        <div class="d-flex justify-content-between align-items-center">
            <h3 class="text-primary mb-2">تنظیمات جایگاه‌ها</h3>
            <div v-if="isAdminIdentityVerified" class="d-flex justify-content-md-end justify-content-center mb-2">
                <b-button @click="showModalCreate" variant="primary" class="px-3">
                    ایجاد
                </b-button>
            </div>
        </div>
        <div v-if="isAdminIdentityVerified">
            <b-card class="p-0" no-body>
                <b-overlay v-if="tables.length" :show="loading" variant="transparent" opacity="1" blur="3px"
                    rounded="sm">
                    <b-table responsive :items="tables" :fields="fields" class="mb-0" striped>
                        <template #cell(edit)="data">
                            <feather-icon @click="showModalEdit(data.item)" size="18" icon="EditIcon"
                                class="pointer text-info" color="#8d88a3" />
                        </template>
                        <template #cell(isActive)="data">
                            <span v-if="data.item.isActive" class="text-success">فعال</span>
                            <span v-else class="text-danger">غیرفعال</span>
                        </template>
                    </b-table>
                </b-overlay>
                <div v-else class="text-center py-5">
                    موردی وجود ندارد
                </div>
            </b-card>
            <b-pagination align="center" @input="getTables" v-model="parameters.pageIndex"
                :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
        </div>

        <b-card v-if="!isAdminIdentityVerified">
            <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                <span>برای دسترسی به این قسمت، لطفا</span>
                <router-link class="mx-25" to="/identity-management">هویت</router-link>
                <span>خود را تایید کنید.</span>
            </div>
        </b-card>

        <!------------------------------- modal create and edit ------------------------------->
        <b-modal id="tables-modal" :title="`${tableMode}`" centered :hide-footer="true" title-class="font-weight-bolder"
            size="md">
            <div class="p-1">
                <validation-observer ref="tableValidation">
                    <b-form @submit.prevent>
                        <!-- name -->
                        <b-form-group label="نام" label-for="nameId" class="text-center">
                            <validation-provider #default="{ errors }" name="نام" rules="required">
                                <b-form-input autocomplete="off" dir="rtl" id="nameId" v-model="form.name" name="name"
                                    class="text-center user-select-none" :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!------------ capacity ------------>
                        <b-form-group label="ظرفیت" label-for="capacityId" class="text-center">
                            <validation-provider #default="{ errors }" name="ظرفیت" rules="required">
                                <b-form-input type="number" autocomplete="off" dir="ltr" id="capacityId"
                                    v-model="form.capacity" name="capacity" class="text-center user-select-none"
                                    :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!------------ isActive ------------>
                        <b-form-group label="وضعیت" label-for="categoryId" class="text-center">
                            <validation-provider #default="{ errors }" name="دسته" rules="required">
                                <v-select v-model="form.isActive" :searchable="false" dir="rtl"
                                    :reduce="(value) => value.id" class="bg-white" style="border-radius: 6px;"
                                    label="name" :clearable="false" :options="isActiveList">
                                    <template #no-options>
                                        موردی وجود ندارد
                                    </template>
                                </v-select>
                            </validation-provider>
                        </b-form-group>

                        <b-button type="submit" variant="primary" @click="managementTable" :disabled="loadingButton"
                            class="w-100 mt-2 d-flex align-items-center justify-content-center">
                            <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                            <span>{{ tableMode }}</span>
                        </b-button>
                    </b-form>
                </validation-observer>
            </div>
        </b-modal>

    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BForm, BFormRadio, BFormTextarea, BTable, BPagination, BOverlay, BAvatar, BMediaAside, BMedia, BMediaBody, BFormInput, BFormGroup, BSpinner, BBadge } from 'bootstrap-vue';
import { storeService } from '@core/services';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';
import vSelect from 'vue-select';

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BAvatar,
        BMediaAside,
        BMedia,
        BSpinner,
        BMediaBody,
        BFormInput,
        BFormGroup,
        BForm,
        BFormRadio,
        BFormTextarea,
        BBadge,
        vSelect
    },
    data() {
        return {
            required,
            loadingPage: true,
            loading: false,
            loadingButton: false,
            isAdminIdentityVerified: false,
            tables: [],
            isActiveList: [
                { name: 'فعال', id: true },
                { name: 'غیرفعال', id: false }
            ],
            fields: [
                {
                    key: 'id',
                    label: 'شناسه',
                },
                {
                    key: 'name',
                    label: 'نام',
                },
                {
                    key: 'isActive',
                    label: 'وضعیت',
                },

                {
                    key: 'capacity',
                    label: 'ظرفیت',
                },
                {
                    key: 'edit',
                    label: 'ویرایش',
                },
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
            },
            storeId: null,
            form: {
                name: null,
                isActive: true,
                capacity: null,
            },
            tableMode: null,
            tableId: null,
        }
    },
    methods: {
        managementTable() {
            if (this.tableMode == 'ایجاد') {
                this.createTable()
            }
            if (this.tableMode == 'ویرایش') {
                this.editTable()
            }
        },
        showModalEdit(item) {
            this.tableMode = 'ویرایش'
            this.tableId = item.id
            this.form.name = item.name
            this.form.capacity = item.capacity
            this.form.isActive = item.isActive
            this.$bvModal.show('tables-modal')
        },
        showModalCreate() {
            this.tableMode = 'ایجاد'
            this.form.name = null
            this.form.capacity = null
            this.form.isActive = true
            this.$bvModal.show('tables-modal')
        },
        editTable() {
            this.$refs.tableValidation.validate().then((success) => {
                if (success) {
                    this.loadingButton = true
                    storeService.editTable(this.storeId, this.tableId, this.form).then(({ data }) => {
                        this.$refs.tableValidation.reset();
                        this.$notif({ type: 'success', title: 'جایگاه با موفقیت ویرایش شد' });
                        this.$bvModal.hide('tables-modal')
                        this.getTables()
                    })
                        .finally(() => {
                            this.loadingButton = false
                        });
                }
            });
        },
        createTable() {
            this.$refs.tableValidation.validate().then((success) => {
                if (success) {
                    this.loadingButton = true
                    storeService.createTable(this.storeId, this.form).then(({ data }) => {
                        this.$refs.tableValidation.reset();
                        this.$notif({ type: 'success', title: 'جایگاه با موفقیت ایجاد شد' });
                        this.$bvModal.hide('tables-modal')
                        this.getTables()
                    })
                        .finally(() => {
                            this.loadingButton = false
                        });
                }
            });
        },
        getCompletionStatus() {
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified
                if (this.isAdminIdentityVerified) {
                    this.getTables()
                }
                else {
                    this.loadingPage = false;
                }
            })
        },
        getTables() {
            this.loading = true
            storeService.getTables(this.storeId, this.parameters).then(({ data }) => {
                if (this.loadingPage) {
                    this.parameters.totalCount = data.totalCount
                    this.tables = data.items
                    this.loading = false
                }
                else {
                    setTimeout(() => {
                        this.parameters.totalCount = data.totalCount
                        this.tables = data.items
                        this.loading = false
                    }, 369)
                }
                this.loadingPage = false
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        this.getCompletionStatus()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>